module.exports = __webpack_public_path__ + "static/media/imageWordCard.48c55a3b.svg";